/* eslint-disable max-classes-per-file */

/* Analytics template for SPA Vue2 */
/* It is intended to substitute gtm analytics and give a point to add another analytics plugin and proxy data to it. */

import { origin as rawMetaOrigin } from '@/assets/data/meta.json';

const isProd = process.env.NODE_ENV === 'production';

const checkProd = () => {
    if (!isProd) return false;

    const { origin } = window.location;
    const { origin: metaOrigin } = new URL(rawMetaOrigin);

    return metaOrigin === origin;
};

const defaultTrackParams = {
    event: 'eventTracking',
    action: 'Click'
};

class DevGTMTracker {
    trackEvent(data) {
        console.debug('Tracking event with params: ', data);
    }
}

class AnalyticsProxy {
    constructor(vueGtm) {
        this.tracker = vueGtm;
    }

    sendEvent(params) {
        if (!this.tracker) return;

        this.tracker.trackEvent({
            ...defaultTrackParams,
            ...params
        });
    }

    // Specific methods example:
    outbound(href) {
        this.sendEvent({
            category: 'Outbound',
            label: href
        });
    }

    share(platform) {
        this.sendEvent({
            category: 'Share',
            label: platform
        });
    }
}

const getAnalyticsProxyTracker = (/* Vue */) => {
    if (checkProd()) {
        return null;
    }

    return new DevGTMTracker();
};

const AnalyticsPlugin = (Vue) => {
    const tracker = getAnalyticsProxyTracker(Vue);
    const analyticsProxy = new AnalyticsProxy(tracker);

    Vue.prototype.$analytics = analyticsProxy;
};

export default AnalyticsPlugin;
